<section class="exams-page fill-column">
  <h1 data-clarity-unmask="true">Egzaminy</h1>

  <div class="exams-card fill-column">
    <div class="exams-toolbar">
      <p-button
        label="Drukuj zaznaczone"
        icon="pi pi-print"
        [disabled]="selectedExams.length === 0 || printing"
        [loading]="printing"
        (onClick)="printSelected()" data-clarity-unmask="true">
      </p-button>

      <div class="exams-toolbar__filters">
        <span class="fas-table-filter-bar__search exams-search">
          <i class="pi pi-search"></i>
          <input
            #searchInput
            pInputText
            type="search"
            placeholder="Wyszukaj"
            class="fas-table-filter-bar__search-input"
            (input)="onSearch(searchInput.value)" />
        </span>

        <label for="exam-source">Pokaż:</label>
        <p-dropdown
          inputId="exam-source"
          [options]="sourceOptions"
          [(ngModel)]="selectedSource"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          (onChange)="onSourceChange()">
        </p-dropdown>
      </div>
    </div>

    <p-table
      #examTable
      dataKey="guid"
      class="table-height"
      styleClass="exams-table"
      [scrollable]="true"
      scrollHeight="flex"
      [value]="exams"
      [lazy]="true"
      [loading]="loading"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[10, 25, 50]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{totalRecords} wyników"
      [(selection)]="selectedExams"
      (onLazyLoad)="loadExams($event)">

      <ng-template pTemplate="header">
        <tr>
          <th class="exams-table__checkbox">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th>Data wykonania</th>
          <th>
            Nazwa użytkownika<br />
            <small>(Imię i Nazwisko)</small>
          </th>
          <th>Adres e-mail</th>
          <th>Kategoria</th>
          <th>Ilość punktów</th>
          <th class="exams-table__actions">Akcje</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-exam>
        <tr>
          <td class="exams-table__checkbox">
            <p-tableCheckbox [value]="exam"></p-tableCheckbox>
          </td>
          <td>{{ exam.completedAt | date : "dd.MM.yyyy HH:mm" }}</td>
          <td>
            <strong>{{ exam.displayName || "—" }}</strong>
          </td>
          <td>{{ exam.email }}</td>
          <td>{{ exam.examCategory }}</td>
          <td>
            <div
              class="exam-score"
              [class.exam-score--passed]="
                hasResult(exam) && isPassed(exam.internalExamResult)
              "
              [class.exam-score--failed]="
                hasResult(exam) && isFailed(exam.internalExamResult)
              ">
              <span
                *ngIf="hasResult(exam)"
                class="exam-score__status"
                [pTooltip]="statusTooltip(exam)"
                tooltipPosition="top">
                <i class="pi" [ngClass]="sourceIcon(exam)"></i>
              </span>
              <span>{{ exam.earnedPoints }}/{{ exam.availablePoints }}</span>
            </div>
          </td>
          <td class="exams-table__actions">
            <button
              type="button"
              class="exam-action pi pi-eye"
              pTooltip="Zobacz egzamin"
              tooltipPosition="bottom"
              (click)="showExam(exam)" data-clarity-unmask="true">
            </button>
            <button
              type="button"
              class="exam-action pi pi-calendar"
              pTooltip="Zmień datę wykonania egzaminu"
              tooltipPosition="bottom"
              (click)="changeExamDate(exam)" data-clarity-unmask="true">
            </button>
            <button
              type="button"
              class="exam-action pi pi-print"
              pTooltip="Pobierz"
              tooltipPosition="bottom"
              [disabled]="printing"
              (click)="printExam(exam)" data-clarity-unmask="true">
            </button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="exams-table__empty">
            Brak egzaminów spełniających wybrane kryteria.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
